module.exports = __webpack_public_path__ + "img/abstraktion-fashion-logo.e557cc9c.svg";